import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Login from './pages/login/login.js';
import ProtectedRoute from './pages/protectedRoute/protectedRoute.js';
import { LoginProvider } from './context/loginContext.js';
import MainLayout from './pages/layout/layout.js';
// ADMINISTRADOR
import CUsuarios from './pages/administrador/usuarios/usuarios.js';
import Home from './pages/administrador/home/home.js';
// CLIENTE
import CInicioCliente from './pages/cliente/home-cliente.js';
import CCuentas from './pages/cliente/cuentas/cuentas.js';
import CCerealesCliente from './pages/cliente/cereales/cereales-cliente.js';
import CSupermercadoCliente from './pages/cliente/supermercado/supermercado-cliente.js';
import CHaciendaCliente from './pages/cliente/hacienda/hacienda-cliente.js';
import CDifundir from './pages/cliente/difundir/difundir-cliente.js';
import CAuditoriaCliente from './pages/cliente/auditoria/auditoria-cliente.js';
import CDifundirRomaneos from './pages/cliente/difundir/difundir-romaneos.js';
import CDifundirCereales from './pages/cliente/difundir/difundir-cereales.js';
import CDifundirResumenCuenta from './pages/cliente/difundir/difundir-resumen-cuenta.js';
import CDifundirNoticia from './pages/cliente/difundir/difundir-noticia.js';
import CImprimirResumenCuenta from './pages/cliente/imprimir-resumen-cuenta/imprimir-resumen-cuenta.js';
import { setupAxiosInterceptors } from './authAxios.js';

function App() {
  useEffect(() => {
    const ejectInterceptors = setupAxiosInterceptors();
    return () => ejectInterceptors();
  }, []);

  // Simulación de carga de configuración del tema
  const [themeConfig] = useState({
    colorPrimary: '#FB6B48', 
    borderRadius: 4,
    Button: {
      colorPrimary: '#FB6B48',
      algorithm: true,
    },
  });
  return (
<ConfigProvider
  theme={{
    token: {
      colorPrimary: themeConfig.colorPrimary,
      borderRadius: themeConfig.borderRadius,
    },
    components: {
      Button: {
        colorPrimary: themeConfig.Button?.colorPrimary,
        algorithm: themeConfig.Button?.algorithm,
      },
    },
  }}
>
      <LoginProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Protegemos todas las rutas */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <Home />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/usuarios"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CUsuarios allowedRoles={['administrador']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/home-cliente"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CInicioCliente allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuentas"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CCuentas allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cereales"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CCerealesCliente allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/supermercado"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CSupermercadoCliente allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/hacienda"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CHaciendaCliente allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/auditoria"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CAuditoriaCliente allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/difundir"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CDifundir allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/difundir-romaneos"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CDifundirRomaneos allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/difundir-cereales"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CDifundirCereales allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/difundir-resumen-cuenta"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CDifundirResumenCuenta allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/difundir-noticia"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CDifundirNoticia allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/imprimir-resumen-cuenta"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CImprimirResumenCuenta allowedRoles={['cliente']} />
                  </MainLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;